import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { finalize, Observable } from 'rxjs';
import { GlobalService } from '../services/global/global.service';
import { SPINNER } from '../tokens/http-context.tokens';

@Injectable({
  providedIn: 'root'
})
export class AccessTokenInterceptorService implements HttpInterceptor {

  constructor(private _globalService: GlobalService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Retrieve the spinner control flag from the request context
    const showSpinner = req.context.get(SPINNER);    

    if (showSpinner) {
      this._globalService.showLoadingSpinner();
    }

    // Add Authorization header if access token exists
    const accessToken = localStorage.getItem("Authorization");
    if (accessToken) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    }

    // Handle the request and hide the spinner on completion
    return next.handle(req).pipe(
      finalize(() => {
        if (showSpinner) {
          this._globalService.hideLoadingSpinner();
        }
      })
    );
  }
}
